// import React, {
//   useContext,
//   useState,
//   useEffect,
//   useCallback,
//   useMemo,
// } from "react";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { useLocation } from "react-router-dom";

// export default function Invoice({ onSuccess = () => {} }) {
//   const location = useLocation();
//   const { state } = location;
//   const isEditMode = state?.isEditMode || false;
//   const initialData = state?.invoiceData || null;
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [logo, setLogo] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [submittedInvoiceId, setSubmittedInvoiceId] = useState(null);
//   const [items, setItems] = useState(() => {
//     return isEditMode && initialData?.item
//       ? initialData.item
//       : [
//           {
//             productName: "",
//             quantity: 1,
//             cost: 0,
//             discount: 0,
//             total: 0,
//             sacNo: "",
//             comment: "",
//           },
//         ];
//   });

//   const [formData, setFormData] = useState(() => {
//     const baseData = {
//       companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//       invoiceType: "",
//       emailAutomation: false,
//       name: "",
//       companyName: "",
//       companyContact: "",
//       billType: "",
//       companyEmail: "",
//       gstNo: "",
//       gstType: "",
//       panNo: "",
//       stateName: "",
//       pinCode: "",
//       stateCode: "",
//       companyAddress: "",
//       termAndCondition: "",
//       createdById: user?.id,
//       createdByName: user?.name,
//       createdAt: new Date().toISOString().split("T")[0],
//       salesPerson: {
//         userId: "",
//         name: "",
//         mobileNumber: "",
//         email: "",
//       },
//       billDetails: {
//         subTotal: "0.00",
//         totalDiscount: 0,
//         totalAmount: 0.0,
//         paidAmount: 0.0,
//         dueAmount: 0.0,
//         cgstAmount: 0.0,
//         sgstAmount: 0.0,
//         igstAmount: 0.0,
//       },
//     };
//     return isEditMode && initialData
//       ? { ...baseData, ...initialData }
//       : baseData;
//   });

//   const [companyDetails, setCompanyDetails] = useState({
//     companyName: "",
//     email: "",
//     mobileNumber: "",
//     gstNo: "",
//     panNo: "",
//     companyAddress: "",
//     stateName: "",
//     stateCode: "",
//     statePin: "",
//     fname: "",
//     lname: "",
//     profileImage: "",
//     taxSlabs: "",
//     bankDetails: {
//       inFavorOf: "",
//       bankName: "",
//       accountNo: "",
//       ifscCode: "",
//       paymentMode: "",
//     },
//   });

//   // Calculate totals for the summary
//   const summary = useMemo(() => {
//     let cgstAmount = 0;
//     let sgstAmount = 0;
//     let igstAmount = 0;

//     const subtotal = items.reduce(
//       (sum, item) => sum + item.quantity * item.cost,
//       0
//     );
//     const totalWithoutDiscount = subtotal;
//     const totalWithDiscount = items.reduce((sum, item) => sum + item.total, 0);
//     const totalDiscount = totalWithoutDiscount - totalWithDiscount;
//     const total = subtotal - totalDiscount;

//     let paidAmount = parseFloat(formData.paidAmount) || 0;
//     let dueAmount;

//     // Calculate GST based on GST type and state codes

//     const gstRate = companyDetails.taxSlabs; // Assuming 18% GST rate

//     if (
//       formData.gstType === "SGST/CGST"
//       // formData.stateCode === companyDetails.stateCode
//     ) {
//       // For same state transactions, split GST into SGST and CGST
//       cgstAmount = (total * (gstRate / 2)) / 100;
//       sgstAmount = (total * (gstRate / 2)) / 100;
//     } else if (
//       formData.gstType === "IGST" ||
//       (formData.gstType === "SGST/CGST" &&
//         formData.stateCode !== companyDetails.stateCode)
//     ) {
//       // For different state transactions, apply IGST
//       igstAmount = (total * gstRate) / 100;
//     }

//     if (formData.invoiceType === "Paid") {
//       paidAmount = (total + cgstAmount + sgstAmount + igstAmount).toFixed(2);
//     } else if (formData.invoiceType === "Unpaid") {
//       paidAmount = 0;
//     }
//     dueAmount =
//       (total + cgstAmount + sgstAmount + igstAmount).toFixed(2) - paidAmount;

//     setFormData((prev) => ({
//       ...prev,
//       subTotal: subtotal.toFixed(2),
//       totalDiscount: totalDiscount.toFixed(2),
//       totalAmount: (total + cgstAmount + sgstAmount + igstAmount).toFixed(2),
//       paidAmount: paidAmount,
//       dueAmount: dueAmount.toFixed(2),
//       cgstAmount: cgstAmount.toFixed(2),
//       sgstAmount: sgstAmount.toFixed(2),
//       igstAmount: igstAmount.toFixed(2),
//     }));

//     return {
//       subtotal: subtotal.toFixed(2),
//       totalDiscount: totalDiscount.toFixed(2),
//       total: total.toFixed(2),
//       cgstAmount: cgstAmount.toFixed(2),
//       sgstAmount: sgstAmount.toFixed(2),
//       igstAmount: igstAmount.toFixed(2),
//     };
//   }, [
//     items,
//     formData.invoiceType,
//     formData.paidAmount,
//     formData.gstType,
//     formData.stateCode,
//     companyDetails.stateCode,
//   ]);

//   // Auto-select GST type when state codes match
//   useEffect(() => {
//     if (formData.stateCode && companyDetails.stateCode) {
//       if (formData.stateCode === companyDetails.stateCode) {
//         setFormData((prev) => ({
//           ...prev,
//           gstType: "SGST/CGST",
//         }));
//       } else {
//         setFormData((prev) => ({
//           ...prev,
//           gstType: "IGST",
//         }));
//       }
//     }
//   }, [formData.stateCode, companyDetails.stateCode]);

//   // Calculate total whenever quantity, cost, or discount changes
//   const calculateTotal = (quantity, cost, discount) => {
//     const qty = parseFloat(quantity) || 0;
//     const cst = parseFloat(cost) || 0;
//     const dsc = parseFloat(discount) || 0;
//     return qty * cst - (qty * cst * dsc) / 100; // Now discount is percentage based
//   };

//   const handleItemChange = (index, field, value) => {
//     const newItems = [...items];
//     newItems[index][field] = value;

//     // Recalculate total if quantity, cost, or discount changes
//     if (field === "quantity" || field === "cost" || field === "discount") {
//       newItems[index].total = calculateTotal(
//         newItems[index].quantity,
//         newItems[index].cost,
//         newItems[index].discount
//       );
//     }

//     setItems(newItems);
//   };

//   const handlePaidAmountChange = (e) => {
//     const paidAmount = parseFloat(e.target.value) || 0;
//     const totalAmount = parseFloat(formData.totalAmount) || 0;

//     // Don't allow paidAmount to exceed totalAmount
//     const newPaidAmount = Math.min(paidAmount, totalAmount);

//     setFormData((prev) => ({
//       ...prev,
//       paidAmount: newPaidAmount,
//       dueAmount: (totalAmount - newPaidAmount).toFixed(2),
//       // Automatically set invoiceType to "Half Paid" if user manually enters a paid amount
//       invoiceType:
//         newPaidAmount > 0 && newPaidAmount < totalAmount
//           ? "Half Paid"
//           : prev.invoiceType,
//     }));
//   };

//   const getProfileImageUrl = useCallback(async (filename) => {
//     if (!filename) {
//       setLogo(null);
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `${API_URL}/api/user/profileImage/${filename}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//           responseType: "blob",
//         }
//       );

//       const imageUrl = URL.createObjectURL(response.data);
//       setLogo(imageUrl);
//     } catch (error) {
//       console.error("Error loading profile image:", error);
//       setLogo(null);
//     }
//   }, []);

//   const fetchCompanyProfile = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axios.get(
//         `${API_URL}/api/user/details/${user?.id}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       const data = response.data;
//       setCompanyDetails((prev) => ({
//         ...prev,
//         companyName: data.companyName || prev.companyName,
//         email: data.email || prev.email,
//         mobileNumber: data.mobileNumber || prev.mobileNumber,
//         gstNo: data.gstNo || prev.gstNo,
//         panNo: data.panNo || prev.panNo,
//         companyAddress: data.companyAddress || prev.companyAddress,
//         stateName: data.stateName || prev.stateName,
//         stateCode: data.stateCode || prev.stateCode,
//         statePin: data.statePin || prev.statePin,
//         fname: data.fname || prev.fname,
//         lname: data.lname || prev.lname,
//         profileImage: data.profileImage || prev.profileImage,
//         taxSlabs: data.taxSlabs || prev.taxSlabs,
//         bankDetails: data.bankDetails || prev.bankDetails,
//       }));

//       if (data.profileImage) {
//         await getProfileImageUrl(data.profileImage);
//       }
//     } catch (error) {
//       console.error("Failed to fetch company profile:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCompanyProfile();
//   }, []);

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }

//     fetchUsers();
//   }, [user]);

//   const handleSalesPersonChange = (e) => {
//     const selectedUser = users.find((u) => u.id === e.target.value);
//     if (selectedUser) {
//       setFormData((prev) => ({
//         ...prev,
//         salesPerson: {
//           userId: selectedUser.id,
//           name: `${selectedUser.fname} ${selectedUser.lname}`,
//           email: selectedUser.email,
//           mobileNumber: selectedUser.mobileNumber,
//         },
//       }));
//     }
//   };

//   const handleFormChange = (e) => {
//     const { name, value } = e.target;

//     // Special handling for paidAmount to update dueAmount
//     if (name === "paidAmount") {
//       handlePaidAmountChange(e);
//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async () => {
//     // Create the billDetails object with the required fields
//     const billDetails = {
//       subTotal: formData.subTotal,
//       totalDiscount: formData.totalDiscount,
//       totalAmount: formData.totalAmount,
//       paidAmount: formData.paidAmount,
//       dueAmount: formData.dueAmount,
//       cgstAmount: formData.cgstAmount,
//       sgstAmount: formData.sgstAmount,
//       igstAmount: formData.igstAmount,
//     };

//     // Create the payload with billDetails
//     const payload = {
//       ...formData,
//       item: items,
//       billDetails: billDetails,
//     };

//     // Remove the duplicate fields from the root level
//     delete payload.subTotal;
//     delete payload.totalDiscount;
//     delete payload.totalAmount;
//     delete payload.paidAmount;
//     delete payload.dueAmount;
//     delete payload.cgstAmount;
//     delete payload.sgstAmount;
//     delete payload.igstAmount;

//     try {
//     let response;
//     if (isEditMode) {
//       // Update existing invoice
//       response = await axios.put(
//         `${API_URL}/api/invoices/${initialData.invoiceId}`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       alert("Invoice updated successfully!");
//       onSuccess();
//     } else {
//       // Create new invoice
//       response = await axios.post(`${API_URL}/api/invoices`, payload, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
      
//       // Check if response.data exists and has either 'id' or 'invoiceId'
//       const invoiceId = response.data?.id || response.data?.invoiceId;
//       if (!invoiceId) {
//         throw new Error("Invoice ID not found in response");
//       }
      
//       setSubmittedInvoiceId(invoiceId);
//       alert("Invoice created successfully! You can now download it.");
//     }
//   } catch (error) {
//     console.error(
//       `Error ${isEditMode ? "updating" : "creating"} invoice:`,
//       error
//     );
//     alert(`Failed to ${isEditMode ? "update" : "create"} invoice`);
//   }
// };

//   useEffect(() => {
//     if (isEditMode && initialData) {
//       setFormData((prev) => ({ ...prev, ...initialData }));
//       if (initialData.item) {
//         setItems(initialData.item);
//       }
//     }
//   }, [isEditMode, initialData]);

//   const handleDownloadPDF = async () => {
//     if (!submittedInvoiceId) return;

//     try {
//       const response = await axios.get(
//         `${API_URL}/api/invoices/${submittedInvoiceId}/pdf`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//           responseType: "blob",
//         }
//       );

//       // Extract filename from response headers
//       const disposition = response.headers["content-disposition"];
//       let filename = "invoice.pdf"; // fallback name

//       if (disposition && disposition.includes("filename=")) {
//         const match = disposition.match(/filename="?(.+)"?/);
//         if (match && match[1]) {
//           filename = match[1];
//         }
//       }

//       // Create blob and download
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } catch (error) {
//       console.error("Error downloading PDF:", error);
//       alert("Failed to download PDF");
//     }
//   };

//   const handleAddItem = () => {
//     setItems([
//       ...items,
//       {
//         productName: "",
//         quantity: 1,
//         cost: 0,
//         discount: 0,
//         total: 0,
//         sacNo: "",
//         comment: "",
//       },
//     ]);
//   };

//   const handleRemoveItem = (index) => {
//     const newItems = [...items];
//     newItems.splice(index, 1);
//     setItems(newItems);
//   };

//   return (
//     <div className=" mx-auto p-2 space-y-4 text-sm text-gray-700 dark:text-white dark:bg-gray-900">
//       {/* Header Section with Company Details */}
//       <div className="flex flex-col md:flex-row justify-between items-start gap-6 p-4 bg-gray-100 rounded-lg shadow-sm border dark:bg-gray-900 dark:text-white">
//         {/* Left: Company Info */}
//         <div className="flex items-start gap-4 w-full md:w-2/3">
//           <div className="flex-shrink-0">
//             <img
//               src={logo || "/logo.png"}
//               alt="Profile"
//               className="h-20 w-20 rounded-lg object-cover border border-gray-200"
//             />
//           </div>
//           <div className="space-y-1">
//             <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
//               {companyDetails.companyName}
//             </h2>
//             {(companyDetails.fname || companyDetails.lname) && (
//               <p className="text-sm text-gray-600 dark:text-white">
//                 {companyDetails.fname} {companyDetails.lname}
//               </p>
//             )}
//             {companyDetails.email && (
//               <p className="text-sm text-gray-600 dark:text-white">
//                 {companyDetails.email}
//               </p>
//             )}
//             {companyDetails.mobileNumber && (
//               <p className="text-sm text-gray-600 dark:text-white">
//                 {companyDetails.mobileNumber}
//               </p>
//             )}
//             {companyDetails.companyAddress && (
//               <p className="text-sm text-gray-600 dark:text-white">
//                 {companyDetails.companyAddress}, {companyDetails.stateName} -{" "}
//                 {companyDetails.statePin}
//               </p>
//             )}
//           </div>
//         </div>

//         {/* Right: Date & Bank Details */}
//         <div className="w-full md:w-1/3 space-y-3">
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               Date:
//             </label>
//             <input
//               type="date"
//               name="createdAt"
//               value={formData.createdAt}
//               onChange={handleFormChange}
//               className="border rounded px-3 py-1.5 text-sm w-full focus:outline-none focus:ring-1 focus:ring-blue-400 dark:bg-gray-700 dark:text-white"
//             />
//           </div>

//           <div className="mt-2 border-t pt-3">
//             <h3 className="text-md font-semibold text-gray-800 mb-2 dark:text-white">
//               Bank Details
//             </h3>
//             <div className="space-y-1 text-sm text-gray-700 dark:text-white">
//               <p>
//                 <span className="font-medium">In Favor Of:</span>{" "}
//                 {companyDetails.bankDetails.inFavorOf}
//               </p>
//               <p>
//                 <span className="font-medium">Bank Name:</span>{" "}
//                 {companyDetails.bankDetails.bankName}
//               </p>
//               <p>
//                 <span className="font-medium">Account No:</span>{" "}
//                 {companyDetails.bankDetails.accountNo}
//               </p>
//               <p>
//                 <span className="font-medium">IFSC Code:</span>{" "}
//                 {companyDetails.bankDetails.ifscCode}
//               </p>
//               <p>
//                 <span className="font-medium">Payment Mode:</span>{" "}
//                 {companyDetails.bankDetails.paymentMode}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bill Type Dropdown */}
// <div className="bg-gray-100 rounded-lg shadow-sm border p-4 dark:text-white dark:bg-gray-900 mb-4">
//   <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//     Bill Type
//   </label>
//   <select
//     name="billType"
//     value={formData.billType || ""}
//     onChange={handleFormChange}
//     className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//   >
//     <option value="">Select Bill Type</option>
//     <option value="Invoice">Invoice</option>
//     <option value="Quotation">Quotation </option>
//     <option value="Proforma">Proforma Invoice</option>
//     <option value="Receipt">Receipt</option>
//   </select>
// </div>

//       {/* To: Company Details Section (Empty Form) */}
//       <div className="bg-gray-100 rounded-lg shadow-sm border p-4 dark:text-white dark:bg-gray-900">
//         <h3 className="text-base font-medium text-gray-800 mb-3 dark:text-white">
//           To:
//         </h3>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               Name
//             </label>
//             <input
//               name="name"
//               value={formData.name}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               Company Name
//             </label>
//             <input
//               name="companyName"
//               value={formData.companyName}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               Company Contact
//             </label>
//             <input
//               name="companyContact"
//               value={formData.companyContact}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               Company Email
//             </label>
//             <input
//               name="companyEmail"
//               value={formData.companyEmail}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               GST No.
//             </label>
//             <input
//               name="gstNo"
//               value={formData.gstNo}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               PAN No.
//             </label>
//             <input
//               name="panNo"
//               value={formData.panNo}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-fulldark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               State Name
//             </label>
//             <input
//               name="stateName"
//               value={formData.stateName}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               Pin Code
//             </label>
//             <input
//               name="pinCode"
//               value={formData.pinCode}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               State Code
//             </label>
//             <input
//               name="stateCode"
//               value={formData.stateCode}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               Company Address
//             </label>
//             <input
//               name="companyAddress"
//               value={formData.companyAddress}
//               onChange={handleFormChange}
//               className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//             />
//           </div>
//           <div className="md:col-span-2 lg:col-span-3">
//             <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//               GST Type:
//             </label>
//             <div className="flex gap-3">
//               <label className="flex items-center gap-1 text-sm">
//                 <input
//                   type="radio"
//                   name="gstType"
//                   value="Non GST"
//                   checked={formData.gstType === "Non GST"}
//                   onChange={() =>
//                     setFormData((prev) => ({ ...prev, gstType: "Non GST" }))
//                   }
//                 />
//                 Non GST
//               </label>
//               <label className="flex items-center gap-1 text-sm">
//                 <input
//                   type="radio"
//                   name="gstType"
//                   value="IGST"
//                   checked={formData.gstType === "IGST"}
//                   onChange={() =>
//                     setFormData((prev) => ({ ...prev, gstType: "IGST" }))
//                   }
//                 />
//                 IGST
//               </label>
//               <label className="flex items-center gap-1 text-sm">
//                 <input
//                   type="radio"
//                   name="gstType"
//                   value="SGST/CGST"
//                   checked={formData.gstType === "SGST/CGST"}
//                   onChange={() =>
//                     setFormData((prev) => ({ ...prev, gstType: "SGST/CGST" }))
//                   }
//                 />
//                 SGST/CGST
//               </label>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Sales Person Section */}
//       <div className="bg-gray-100 rounded-lg shadow-sm border p-4 dark:text-white dark:bg-gray-900">
//         <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//           Sales Person
//         </label>
//         <select
//           name="userId"
//           value={formData.salesPerson.userId}
//           onChange={handleSalesPersonChange}
//           className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//         >
//           <option value="">Select Sales Person</option>
//           {users.map((user) => (
//             <option key={user.id} value={user.id}>
//               {user.fname} {user.lname}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* Items Section */}
//       <div className="bg-gray-100 rounded-lg shadow-sm border p-4 relative dark:text-white dark:bg-gray-900">
//         <div className="flex justify-between items-center mb-3">
//           <h3 className="text-base font-medium text-gray-800 dark:text-white">
//             Items
//           </h3>
//           <button
//             onClick={handleAddItem}
//             className="bg-blue-600 text-white px-3 py-1 text-xs rounded hover:bg-blue-700 transition"
//           >
//             + Add Item
//           </button>
//         </div>

//         {items.map((item, index) => (
//           <div
//             key={index}
//             className="mb-4 border-b pb-4 last:border-b-0 last:pb-0"
//           >
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2 ">
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Product Name
//                 </label>
//                 <input
//                   type="text"
//                   value={item.productName}
//                   onChange={(e) =>
//                     handleItemChange(index, "productName", e.target.value)
//                   }
//                   className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//                 />
//               </div>
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Quantity
//                 </label>
//                 <input
//                   type="number"
//                   value={item.quantity}
//                   onChange={(e) =>
//                     handleItemChange(index, "quantity", e.target.value)
//                   }
//                   className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//                   min="1"
//                 />
//               </div>
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Cost
//                 </label>
//                 <input
//                   type="number"
//                   value={item.cost}
//                   onChange={(e) =>
//                     handleItemChange(index, "cost", e.target.value)
//                   }
//                   onWheel={(e) => e.target.blur()}
//                   className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//                   min="0"
//                   step="0.01"
//                 />
//               </div>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2">
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Discount (%)
//                 </label>
//                 <input
//                   type="number"
//                   value={item.discount}
//                   onChange={(e) =>
//                     handleItemChange(index, "discount", e.target.value)
//                   }
//                   onWheel={(e) => e.target.blur()}
//                   className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//                   min="0"
//                   max="100"
//                 />
//               </div>
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Total
//                 </label>
//                 <input
//                   type="number"
//                   value={item.total.toFixed(2)}
//                   readOnly
//                   className="border rounded px-2 py-1 text-sm w-full bg-gray-100 dark:text-white dark:bg-gray-700"
//                 />
//               </div>
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   SAC No
//                 </label>
//                 <input
//                   type="number"
//                   value={item.sacNo}
//                   onChange={(e) =>
//                     handleItemChange(index, "sacNo", e.target.value)
//                   }
//                   className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//                 />
//               </div>
//             </div>

//             <div className="mb-2">
//               <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                 Comment
//               </label>
//               <input
//                 type="text"
//                 value={item.comment}
//                 onChange={(e) =>
//                   handleItemChange(index, "comment", e.target.value)
//                 }
//                 className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//               />
//             </div>

//             {items.length > 1 && (
//               <button
//                 onClick={() => handleRemoveItem(index)}
//                 className="text-red-600 hover:text-red-800 text-xs underline"
//               >
//                 Remove Item
//               </button>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Summary Section */}
//       <div className="bg-gray-100 rounded-lg shadow-sm border p-4 dark:text-white dark:bg-gray-900">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           <div className="md:col-span-2">
//             <div className="space-y-3">
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Invoice Type
//                 </label>
//                 <select
//                   value={formData.invoiceType}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (value === "Half Paid") {
//                       setFormData((prev) => ({
//                         ...prev,
//                         invoiceType: "Half Paid",
//                         paidAmount: "0",
//                         dueAmount: prev.totalAmount,
//                       }));
//                     } else if (value === "Unpaid") {
//                       setFormData((prev) => ({
//                         ...prev,
//                         invoiceType: "Unpaid",
//                         paidAmount: 0,
//                         dueAmount: prev.totalAmount,
//                       }));
//                     } else if (value === "Paid") {
//                       setFormData((prev) => ({
//                         ...prev,
//                         invoiceType: "Paid",
//                         paidAmount: prev.totalAmount,
//                         dueAmount: 0,
//                       }));
//                     }
//                   }}
//                   className="w-full p-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-600"
//                 >
//                   <option value="">Select Invoice Type</option>
//                   <option value="Half Paid">Partial Paid</option>
//                   <option value="Unpaid">Unpaid</option>
//                   <option value="Paid">Paid</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Terms & Conditions
//                 </label>
//                 <textarea
//                   name="termAndCondition"
//                   value={formData.termAndCondition}
//                   onChange={handleFormChange}
//                   className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//                   rows="3"
//                 />
//               </div>
//               <div>
//                 <label className="block text-xs font-medium text-gray-500 mb-1 dark:text-white">
//                   Email Automation
//                 </label>
//                 <select
//                   name="emailAutomation"
//                   value={formData.emailAutomation}
//                   onChange={handleFormChange}
//                   className="border rounded px-2 py-1 text-sm w-full dark:text-white dark:bg-gray-700"
//                 >
//                   <option value="false">No</option>
//                   <option value="true">Yes</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="space-y-3 dark:text-white dark:bg-gray-900">
//             <div className="flex justify-between border-b pb-1">
//               <span className="font-medium">Subtotal:</span>
//               <span>₹{summary.subtotal}</span>
//             </div>
//             <div className="flex justify-between border-b pb-1">
//               <span className="font-medium">Discount:</span>
//               <span>₹{summary.totalDiscount}</span>
//             </div>
//             <div className="flex justify-between border-b pb-1">
//               <span className="font-medium">Total After Discount:</span>
//               <span>
//                 ₹
//                 {(summary.subtotal - summary.totalDiscount).toLocaleString(
//                   "en-IN",
//                   {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2,
//                   }
//                 )}
//               </span>
//             </div>
//             {formData.gstType === "SGST/CGST" && (
//               <>
//                 <div className="flex justify-between border-b pb-1">
//                   <span className="font-medium">
//                     CGST ({companyDetails.taxSlabs / 2}%):
//                   </span>
//                   <span>₹{summary.cgstAmount}</span>
//                 </div>
//                 <div className="flex justify-between border-b pb-1">
//                   <span className="font-medium">
//                     SGST ({companyDetails.taxSlabs / 2}%):
//                   </span>
//                   <span>₹{summary.sgstAmount}</span>
//                 </div>
//               </>
//             )}
//             {formData.gstType === "IGST" && (
//               <div className="flex justify-between border-b pb-1">
//                 <span className="font-medium">
//                   IGST ({companyDetails.taxSlabs}%):
//                 </span>
//                 <span>₹{summary.igstAmount}</span>
//               </div>
//             )}
//             <div className="flex justify-between border-b-2 border-gray-300 pb-1 font-semibold">
//               <span>Total Amount:</span>
//               <span>₹{formData.totalAmount}</span>
//             </div>
//             <div className="flex justify-between border-b pb-1">
//               <span className="font-medium">Paid Amount:</span>
//               <input
//                 type="number"
//                 name="paidAmount"
//                 value={formData.paidAmount}
//                 onChange={handleFormChange}
//                 className={`border rounded px-2 py-1 text-sm w-24 text-right dark:bg-gray-700 ${
//                   formData.invoiceType === "Paid" ||
//                   formData.invoiceType === "Unpaid"
//                     ? "bg-gray-200"
//                     : ""
//                 }`}
//                 min="0"
//                 disabled={
//                   formData.invoiceType === "Paid" ||
//                   formData.invoiceType === "Unpaid"
//                 }
//               />
//             </div>
//             <div className="flex justify-between border-b-2 border-gray-300 pb-1 font-semibold">
//               <span>Due Amount:</span>
//               <span>₹{formData.dueAmount}</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Submit Buttons */}
//        <div className="flex justify-end gap-2">
//       {!submittedInvoiceId ? (
//         <button
//           onClick={handleSubmit}
//           className="bg-blue-600 text-white px-4 py-1.5 text-sm rounded hover:bg-blue-700"
//         >
//           {isEditMode ? "Update Invoice" : "Create Invoice"}
//         </button>
//       ) : (
//         <div className="flex gap-2">
//           <button
//             onClick={() => {
//               // Reset form to initial state
//               setFormData({
//                 companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//                 invoiceType: "",
//                 emailAutomation: false,
//                 name: "",
//                 companyName: "",
//                 companyContact: "",
//                 companyEmail: "",
//                 gstNo: "",
//                 gstType: "",
//                 panNo: "",
//                 stateName: "",
//                 pinCode: "",
//                 stateCode: "",
//                 companyAddress: "",
//                 termAndCondition: "",
//                 createdById: user?.id,
//                 createdByName: user?.name,
//                 createdAt: new Date().toISOString().split("T")[0],
//                 salesPerson: {
//                   userId: "",
//                   name: "",
//                   mobileNumber: "",
//                   email: "",
//                 },
//                 billDetails: {
//                   subTotal: "0.00",
//                   totalDiscount: 0,
//                   totalAmount: 0.0,
//                   paidAmount: 0.0,
//                   dueAmount: 0.0,
//                   cgstAmount: 0.0,
//                   sgstAmount: 0.0,
//                   igstAmount: 0.0,
//                 },
//               });
//               setItems([
//                 {
//                   productName: "",
//                   quantity: 1,
//                   cost: 0,
//                   discount: 0,
//                   total: 0,
//                   sacNo: "",
//                   comment: "",
//                 },
//               ]);
//               setSubmittedInvoiceId(null);
//             }}
//             className="bg-blue-600 text-white px-4 py-1.5 text-sm rounded hover:bg-blue-700"
//           >
//             Create Another Invoice
//           </button>
//           <button
//             onClick={handleDownloadPDF}
//             className="bg-green-600 text-white px-4 py-1.5 text-sm rounded hover:bg-green-700"
//           >
//             Download PDF
//           </button>
//         </div>
//       )}
// </div>
//     </div>
//   );
// }




import React, {
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";
import { useLocation } from "react-router-dom";
import { FaPlus } from "react-icons/fa"; // Added for consistent button styling

export default function Invoice({ onSuccess = () => {} }) {
  const location = useLocation();
  const { state } = location;
  const isEditMode = state?.isEditMode || false;
  const initialData = state?.invoiceData || null;
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [logo, setLogo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [submittedInvoiceId, setSubmittedInvoiceId] = useState(null);
  const [items, setItems] = useState(() => {
    return isEditMode && initialData?.item
      ? initialData.item
      : [
          {
            productName: "",
            quantity: 1,
            cost: 0,
            discount: 0,
            total: 0,
            sacNo: "",
            comment: "",
          },
        ];
  });

  const [formData, setFormData] = useState(() => {
    const baseData = {
      companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
      invoiceType: "",
      emailAutomation: false,
      name: "",
      companyName: "",
      companyContact: "",
      billType: "",
      companyEmail: "",
      gstNo: "",
      gstType: "",
      panNo: "",
      stateName: "",
      pinCode: "",
      stateCode: "",
      companyAddress: "",
      termAndCondition: "",
      createdById: user?.id,
      createdByName: user?.name,
      createdAt: new Date().toISOString().split("T")[0],
      salesPerson: {
        userId: "",
        name: "",
        mobileNumber: "",
        email: "",
      },
      billDetails: {
        subTotal: "0.00",
        totalDiscount: 0,
        totalAmount: 0.0,
        paidAmount: 0.0,
        dueAmount: 0.0,
        cgstAmount: 0.0,
        sgstAmount: 0.0,
        igstAmount: 0.0,
      },
    };
    return isEditMode && initialData
      ? { ...baseData, ...initialData }
      : baseData;
  });

  const [companyDetails, setCompanyDetails] = useState({
    companyName: "",
    email: "",
    mobileNumber: "",
    gstNo: "",
    panNo: "",
    companyAddress: "",
    stateName: "",
    stateCode: "",
    statePin: "",
    fname: "",
    lname: "",
    profileImage: "",
    taxSlabs: "",
    bankDetails: {
      inFavorOf: "",
      bankName: "",
      accountNo: "",
      ifscCode: "",
      paymentMode: "",
    },
  });

  // Calculate totals for the summary
  const summary = useMemo(() => {
    let cgstAmount = 0;
    let sgstAmount = 0;
    let igstAmount = 0;

    const subtotal = items.reduce(
      (sum, item) => sum + item.quantity * item.cost,
      0
    );
    const totalWithoutDiscount = subtotal;
    const totalWithDiscount = items.reduce((sum, item) => sum + item.total, 0);
    const totalDiscount = totalWithoutDiscount - totalWithDiscount;
    const total = subtotal - totalDiscount;

    let paidAmount = parseFloat(formData.paidAmount) || 0;
    let dueAmount;

    // Calculate GST based on GST type and state codes
    const gstRate = companyDetails.taxSlabs; // Assuming 18% GST rate

    if (formData.gstType === "SGST/CGST") {
      // For same state transactions, split GST into SGST and CGST
      cgstAmount = (total * (gstRate / 2)) / 100;
      sgstAmount = (total * (gstRate / 2)) / 100;
    } else if (
      formData.gstType === "IGST" ||
      (formData.gstType === "SGST/CGST" &&
        formData.stateCode !== companyDetails.stateCode)
    ) {
      // For different state transactions, apply IGST
      igstAmount = (total * gstRate) / 100;
    }

    if (formData.invoiceType === "Paid") {
      paidAmount = (total + cgstAmount + sgstAmount + igstAmount).toFixed(2);
    } else if (formData.invoiceType === "Unpaid") {
      paidAmount = 0;
    }
    dueAmount =
      (total + cgstAmount + sgstAmount + igstAmount).toFixed(2) - paidAmount;

    setFormData((prev) => ({
      ...prev,
      subTotal: subtotal.toFixed(2),
      totalDiscount: totalDiscount.toFixed(2),
      totalAmount: (total + cgstAmount + sgstAmount + igstAmount).toFixed(2),
      paidAmount: paidAmount,
      dueAmount: dueAmount.toFixed(2),
      cgstAmount: cgstAmount.toFixed(2),
      sgstAmount: sgstAmount.toFixed(2),
      igstAmount: igstAmount.toFixed(2),
    }));

    return {
      subtotal: subtotal.toFixed(2),
      totalDiscount: totalDiscount.toFixed(2),
      total: total.toFixed(2),
      cgstAmount: cgstAmount.toFixed(2),
      sgstAmount: sgstAmount.toFixed(2),
      igstAmount: igstAmount.toFixed(2),
    };
  }, [
    items,
    formData.invoiceType,
    formData.paidAmount,
    formData.gstType,
    formData.stateCode,
    companyDetails.stateCode,
  ]);

  // Auto-select GST type when state codes match
  useEffect(() => {
    if (formData.stateCode && companyDetails.stateCode) {
      if (formData.stateCode === companyDetails.stateCode) {
        setFormData((prev) => ({
          ...prev,
          gstType: "SGST/CGST",
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          gstType: "IGST",
        }));
      }
    }
  }, [formData.stateCode, companyDetails.stateCode]);

  // Calculate total whenever quantity, cost, or discount changes
  const calculateTotal = (quantity, cost, discount) => {
    const qty = parseFloat(quantity) || 0;
    const cst = parseFloat(cost) || 0;
    const dsc = parseFloat(discount) || 0;
    return qty * cst - (qty * cst * dsc) / 100; // Now discount is percentage based
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;

    // Recalculate total if quantity, cost, or discount changes
    if (field === "quantity" || field === "cost" || field === "discount") {
      newItems[index].total = calculateTotal(
        newItems[index].quantity,
        newItems[index].cost,
        newItems[index].discount
      );
    }

    setItems(newItems);
  };

  const handlePaidAmountChange = (e) => {
    const paidAmount = parseFloat(e.target.value) || 0;
    const totalAmount = parseFloat(formData.totalAmount) || 0;

    // Don't allow paidAmount to exceed totalAmount
    const newPaidAmount = Math.min(paidAmount, totalAmount);

    setFormData((prev) => ({
      ...prev,
      paidAmount: newPaidAmount,
      dueAmount: (totalAmount - newPaidAmount).toFixed(2),
      // Automatically set invoiceType to "Half Paid" if user manually enters a paid amount
      invoiceType:
        newPaidAmount > 0 && newPaidAmount < totalAmount
          ? "Half Paid"
          : prev.invoiceType,
    }));
  };

  const getProfileImageUrl = useCallback(async (filename) => {
    if (!filename) {
      setLogo(null);
      return;
    }

    try {
      const response = await axios.get(
        `${API_URL}/api/user/profileImage/${filename}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          responseType: "blob",
        }
      );

      const imageUrl = URL.createObjectURL(response.data);
      setLogo(imageUrl);
    } catch (error) {
      console.error("Error loading profile image:", error);
      setLogo(null);
    }
  }, []);

  const fetchCompanyProfile = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${API_URL}/api/user/details/${user?.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const data = response.data;
      setCompanyDetails((prev) => ({
        ...prev,
        companyName: data.companyName || prev.companyName,
        email: data.email || prev.email,
        mobileNumber: data.mobileNumber || prev.mobileNumber,
        gstNo: data.gstNo || prev.gstNo,
        panNo: data.panNo || prev.panNo,
        companyAddress: data.companyAddress || prev.companyAddress,
        stateName: data.stateName || prev.stateName,
        stateCode: data.stateCode || prev.stateCode,
        statePin: data.statePin || prev.statePin,
        fname: data.fname || prev.fname,
        lname: data.lname || prev.lname,
        profileImage: data.profileImage || prev.profileImage,
        taxSlabs: data.taxSlabs || prev.taxSlabs,
        bankDetails: data.bankDetails || prev.bankDetails,
      }));

      if (data.profileImage) {
        await getProfileImageUrl(data.profileImage);
      }
    } catch (error) {
      console.error("Failed to fetch company profile:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyProfile();
  }, []);

  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }

    fetchUsers();
  }, [user]);

  const handleSalesPersonChange = (e) => {
    const selectedUser = users.find((u) => u.id === e.target.value);
    if (selectedUser) {
      setFormData((prev) => ({
        ...prev,
        salesPerson: {
          userId: selectedUser.id,
          name: `${selectedUser.fname} ${selectedUser.lname}`,
          email: selectedUser.email,
          mobileNumber: selectedUser.mobileNumber,
        },
      }));
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    // Special handling for paidAmount to update dueAmount
    if (name === "paidAmount") {
      handlePaidAmountChange(e);
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    // Create the billDetails object with the required fields
    const billDetails = {
      subTotal: formData.subTotal,
      totalDiscount: formData.totalDiscount,
      totalAmount: formData.totalAmount,
      paidAmount: formData.paidAmount,
      dueAmount: formData.dueAmount,
      cgstAmount: formData.cgstAmount,
      sgstAmount: formData.sgstAmount,
      igstAmount: formData.igstAmount,
    };

    // Create the payload with billDetails
    const payload = {
      ...formData,
      item: items,
      billDetails: billDetails,
    };

    // Remove the duplicate fields from the root level
    delete payload.subTotal;
    delete payload.totalDiscount;
    delete payload.totalAmount;
    delete payload.paidAmount;
    delete payload.dueAmount;
    delete payload.cgstAmount;
    delete payload.sgstAmount;
    delete payload.igstAmount;

    try {
      let response;
      if (isEditMode) {
        // Update existing invoice
        response = await axios.put(
          `${API_URL}/api/invoices/${initialData.invoiceId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        alert("Invoice updated successfully!");
        onSuccess();
      } else {
        // Create new invoice
        response = await axios.post(`${API_URL}/api/invoices`, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        
        // Check if response.data exists and has either 'id' or 'invoiceId'
        const invoiceId = response.data?.id || response.data?.invoiceId;
        if (!invoiceId) {
          throw new Error("Invoice ID not found in response");
        }
        
        setSubmittedInvoiceId(invoiceId);
        alert("Invoice created successfully! You can now download it.");
      }
    } catch (error) {
      console.error(
        `Error ${isEditMode ? "updating" : "creating"} invoice:`,
        error
      );
      alert(`Failed to ${isEditMode ? "update" : "create"} invoice`);
    }
  };

  useEffect(() => {
    if (isEditMode && initialData) {
      setFormData((prev) => ({ ...prev, ...initialData }));
      if (initialData.item) {
        setItems(initialData.item);
      }
    }
  }, [isEditMode, initialData]);

  const handleDownloadPDF = async () => {
    if (!submittedInvoiceId) return;

    try {
      const response = await axios.get(
        `${API_URL}/api/invoices/${submittedInvoiceId}/pdf`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          responseType: "blob",
        }
      );

      // Extract filename from response headers
      const disposition = response.headers["content-disposition"];
      let filename = "invoice.pdf"; // fallback name

      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?(.+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // Create blob and download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading PDF:", error);
      alert("Failed to download PDF");
    }
  };

  const handleAddItem = () => {
    setItems([
      ...items,
      {
        productName: "",
        quantity: 1,
        cost: 0,
        discount: 0,
        total: 0,
        sacNo: "",
        comment: "",
      },
    ]);
  };

  const handleRemoveItem = (index) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); 
        .cfg-heading { font-family: 'Sora', sans-serif; } 
        .cfg-font { font-family: 'Inter', sans-serif; }
      `}</style>
      
      <div className="w-full min-h-screen bg-[#FAF8FF] dark:bg-gray-900 p-4 md:p-6 lg:p-8 cfg-font">
        <div className="max-w-7xl mx-auto space-y-6">
          
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-2">
            <h1 className="text-2xl sm:text-3xl font-bold cfg-heading text-[#1F2937] dark:text-white flex items-center gap-2">
              📄 {isEditMode ? "Edit Invoice" : "Create Invoice"}
            </h1>
          </div>

          {/* Header Section with Company Details */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700 flex flex-col md:flex-row justify-between items-start gap-6">
            {/* Left: Company Info */}
            <div className="flex items-start gap-5 w-full md:w-2/3">
              <div className="flex-shrink-0">
                <img
                  src={logo || "/logo.png"}
                  alt="Profile"
                  className="h-24 w-24 rounded-lg object-cover border border-[#E5E7EB] dark:border-gray-600 shadow-sm"
                />
              </div>
              <div className="space-y-1.5">
                <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
                  {companyDetails.companyName}
                </h2>
                {(companyDetails.fname || companyDetails.lname) && (
                  <p className="text-sm font-medium text-[#4B5563] dark:text-gray-300">
                    {companyDetails.fname} {companyDetails.lname}
                  </p>
                )}
                {companyDetails.email && (
                  <p className="text-sm text-[#6B7280] dark:text-gray-400">
                    {companyDetails.email}
                  </p>
                )}
                {companyDetails.mobileNumber && (
                  <p className="text-sm text-[#6B7280] dark:text-gray-400">
                    {companyDetails.mobileNumber}
                  </p>
                )}
                {companyDetails.companyAddress && (
                  <p className="text-sm text-[#6B7280] dark:text-gray-400 max-w-sm leading-relaxed">
                    {companyDetails.companyAddress}, {companyDetails.stateName} -{" "}
                    {companyDetails.statePin}
                  </p>
                )}
              </div>
            </div>

            {/* Right: Date & Bank Details */}
            <div className="w-full md:w-1/3 space-y-4">
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                  Date
                </label>
                <input
                  type="date"
                  name="createdAt"
                  value={formData.createdAt}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>

              <div className="mt-2 border-t border-[#E5E7EB] dark:border-gray-700 pt-4">
                <h3 className="text-base font-bold cfg-heading text-[#1F2937] mb-3 dark:text-white">
                  Bank Details
                </h3>
                <div className="space-y-2 text-sm text-[#4B5563] dark:text-gray-300 bg-[#FAF8FF] dark:bg-gray-700/50 p-4 rounded-lg border border-[#E5E7EB] dark:border-gray-600">
                  <p><span className="font-semibold text-[#1F2937] dark:text-gray-200">In Favor Of:</span> {companyDetails.bankDetails.inFavorOf}</p>
                  <p><span className="font-semibold text-[#1F2937] dark:text-gray-200">Bank Name:</span> {companyDetails.bankDetails.bankName}</p>
                  <p><span className="font-semibold text-[#1F2937] dark:text-gray-200">Account No:</span> {companyDetails.bankDetails.accountNo}</p>
                  <p><span className="font-semibold text-[#1F2937] dark:text-gray-200">IFSC Code:</span> {companyDetails.bankDetails.ifscCode}</p>
                  <p><span className="font-semibold text-[#1F2937] dark:text-gray-200">Payment Mode:</span> {companyDetails.bankDetails.paymentMode}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Bill Type Dropdown */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
            <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
              Bill Type
            </label>
            <select
              name="billType"
              value={formData.billType || ""}
              onChange={handleFormChange}
              className="w-full md:w-1/2 p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
            >
              <option value="">Select Bill Type</option>
              <option value="Invoice">Invoice</option>
              <option value="Quotation">Quotation</option>
              <option value="Proforma">Proforma Invoice</option>
              <option value="Receipt">Receipt</option>
            </select>
          </div>

          {/* To: Company Details Section */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
            <h3 className="text-lg font-bold cfg-heading text-[#1F2937] mb-4 dark:text-white border-b border-[#E5E7EB] dark:border-gray-700 pb-2">
              Billed To
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Name</label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Company Name</label>
                <input
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Company Contact</label>
                <input
                  name="companyContact"
                  value={formData.companyContact}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Company Email</label>
                <input
                  name="companyEmail"
                  value={formData.companyEmail}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">GST No.</label>
                <input
                  name="gstNo"
                  value={formData.gstNo}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">PAN No.</label>
                <input
                  name="panNo"
                  value={formData.panNo}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">State Name</label>
                <input
                  name="stateName"
                  value={formData.stateName}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Pin Code</label>
                <input
                  name="pinCode"
                  value={formData.pinCode}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">State Code</label>
                <input
                  name="stateCode"
                  value={formData.stateCode}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              <div className="md:col-span-2 lg:col-span-3">
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Company Address</label>
                <input
                  name="companyAddress"
                  value={formData.companyAddress}
                  onChange={handleFormChange}
                  className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                />
              </div>
              
              <div className="md:col-span-2 lg:col-span-3 pt-3 border-t border-[#E5E7EB] dark:border-gray-700">
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-3">GST Type</label>
                <div className="flex flex-wrap gap-6">
                  <label className="flex items-center gap-2 text-sm text-[#4B5563] dark:text-gray-300 cursor-pointer hover:text-[#673AB7] transition">
                    <input
                      type="radio"
                      name="gstType"
                      value="Non GST"
                      checked={formData.gstType === "Non GST"}
                      onChange={() => setFormData((prev) => ({ ...prev, gstType: "Non GST" }))}
                      className="text-[#673AB7] focus:ring-[#E9D5FF] w-4 h-4 cursor-pointer"
                    />
                    Non GST
                  </label>
                  <label className="flex items-center gap-2 text-sm text-[#4B5563] dark:text-gray-300 cursor-pointer hover:text-[#673AB7] transition">
                    <input
                      type="radio"
                      name="gstType"
                      value="IGST"
                      checked={formData.gstType === "IGST"}
                      onChange={() => setFormData((prev) => ({ ...prev, gstType: "IGST" }))}
                      className="text-[#673AB7] focus:ring-[#E9D5FF] w-4 h-4 cursor-pointer"
                    />
                    IGST
                  </label>
                  <label className="flex items-center gap-2 text-sm text-[#4B5563] dark:text-gray-300 cursor-pointer hover:text-[#673AB7] transition">
                    <input
                      type="radio"
                      name="gstType"
                      value="SGST/CGST"
                      checked={formData.gstType === "SGST/CGST"}
                      onChange={() => setFormData((prev) => ({ ...prev, gstType: "SGST/CGST" }))}
                      className="text-[#673AB7] focus:ring-[#E9D5FF] w-4 h-4 cursor-pointer"
                    />
                    SGST/CGST
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Sales Person Section */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
            <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
              Sales Person
            </label>
            <select
              name="userId"
              value={formData.salesPerson.userId}
              onChange={handleSalesPersonChange}
              className="w-full md:w-1/2 p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
            >
              <option value="">Select Sales Person</option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.fname} {user.lname}
                </option>
              ))}
            </select>
          </div>

          {/* Items Section */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700 relative">
            <div className="flex justify-between items-center mb-6 border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
              <h3 className="text-lg font-bold cfg-heading text-[#1F2937] dark:text-white">
                Line Items
              </h3>
              <button
                onClick={handleAddItem}
                className="flex items-center gap-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-[#673AB7] px-4 py-2 rounded-md transition font-semibold text-sm dark:bg-purple-900/30 dark:text-purple-300"
              >
                <FaPlus className="w-3.5 h-3.5" /> Add Item
              </button>
            </div>

            <div className="space-y-6">
              {items.map((item, index) => (
                <div
                  key={index}
                  className="bg-[#FAF8FF] dark:bg-gray-700/30 p-4 sm:p-5 rounded-lg border border-[#E5E7EB] dark:border-gray-600 relative group transition-all hover:shadow-md"
                >
                  {items.length > 1 && (
                    <button
                      onClick={() => handleRemoveItem(index)}
                      className="absolute top-4 right-4 text-[#EF4444] hover:text-[#B91C1C] text-sm font-semibold bg-[#FEF2F2] dark:bg-red-900/30 px-3 py-1 rounded transition"
                    >
                      Remove
                    </button>
                  )}
                  
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 mt-2">
                    <div>
                      <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Product Name</label>
                      <input
                        type="text"
                        value={item.productName}
                        onChange={(e) => handleItemChange(index, "productName", e.target.value)}
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                        placeholder="Enter product or service"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Quantity</label>
                      <input
                        type="number"
                        value={item.quantity}
                        onChange={(e) => handleItemChange(index, "quantity", e.target.value)}
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                        min="1"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Cost</label>
                      <input
                        type="number"
                        value={item.cost}
                        onChange={(e) => handleItemChange(index, "cost", e.target.value)}
                        onWheel={(e) => e.target.blur()}
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                        min="0"
                        step="0.01"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Discount (%)</label>
                      <input
                        type="number"
                        value={item.discount}
                        onChange={(e) => handleItemChange(index, "discount", e.target.value)}
                        onWheel={(e) => e.target.blur()}
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                        min="0"
                        max="100"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">SAC No</label>
                      <input
                        type="number"
                        value={item.sacNo}
                        onChange={(e) => handleItemChange(index, "sacNo", e.target.value)}
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Total</label>
                      <input
                        type="number"
                        value={item.total.toFixed(2)}
                        readOnly
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md bg-gray-100 cursor-not-allowed font-semibold text-[#1F2937] dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Comment</label>
                    <input
                      type="text"
                      value={item.comment}
                      onChange={(e) => handleItemChange(index, "comment", e.target.value)}
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                      placeholder="Optional notes for this item"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Summary Section */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Invoice Type</label>
                  <select
                    value={formData.invoiceType}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "Half Paid") {
                        setFormData((prev) => ({
                          ...prev,
                          invoiceType: "Half Paid",
                          paidAmount: "0",
                          dueAmount: prev.totalAmount,
                        }));
                      } else if (value === "Unpaid") {
                        setFormData((prev) => ({
                          ...prev,
                          invoiceType: "Unpaid",
                          paidAmount: 0,
                          dueAmount: prev.totalAmount,
                        }));
                      } else if (value === "Paid") {
                        setFormData((prev) => ({
                          ...prev,
                          invoiceType: "Paid",
                          paidAmount: prev.totalAmount,
                          dueAmount: 0,
                        }));
                      }
                    }}
                    className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                  >
                    <option value="">Select Invoice Type</option>
                    <option value="Half Paid">Partial Paid</option>
                    <option value="Unpaid">Unpaid</option>
                    <option value="Paid">Paid</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Email Automation</label>
                  <select
                    name="emailAutomation"
                    value={formData.emailAutomation}
                    onChange={handleFormChange}
                    className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
                  >
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">Terms & Conditions</label>
                  <textarea
                    name="termAndCondition"
                    value={formData.termAndCondition}
                    onChange={handleFormChange}
                    className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition min-h-[100px]"
                    placeholder="Enter terms and conditions..."
                  />
                </div>
              </div>

              <div className="bg-[#FAF8FF] dark:bg-gray-700/30 p-5 rounded-lg border border-[#E5E7EB] dark:border-gray-600 space-y-3">
                <h3 className="text-lg font-bold cfg-heading text-[#1F2937] dark:text-white mb-4 border-b border-[#E5E7EB] dark:border-gray-600 pb-2">Amount Summary</h3>
                
                <div className="flex justify-between items-center text-[#4B5563] dark:text-gray-300 text-sm">
                  <span className="font-medium">Subtotal:</span>
                  <span>₹{summary.subtotal}</span>
                </div>
                <div className="flex justify-between items-center text-[#4B5563] dark:text-gray-300 text-sm">
                  <span className="font-medium">Total Discount:</span>
                  <span className="text-[#EF4444]">- ₹{summary.totalDiscount}</span>
                </div>
                <div className="flex justify-between items-center text-[#1F2937] dark:text-gray-200 font-semibold border-b border-dashed border-gray-300 dark:border-gray-600 pb-2 mb-2">
                  <span>Total After Discount:</span>
                  <span>₹{(summary.subtotal - summary.totalDiscount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>

                {formData.gstType === "SGST/CGST" && (
                  <>
                    <div className="flex justify-between items-center text-[#4B5563] dark:text-gray-300 text-sm">
                      <span className="font-medium">CGST ({companyDetails.taxSlabs / 2}%):</span>
                      <span>₹{summary.cgstAmount}</span>
                    </div>
                    <div className="flex justify-between items-center text-[#4B5563] dark:text-gray-300 text-sm">
                      <span className="font-medium">SGST ({companyDetails.taxSlabs / 2}%):</span>
                      <span>₹{summary.sgstAmount}</span>
                    </div>
                  </>
                )}
                {formData.gstType === "IGST" && (
                  <div className="flex justify-between items-center text-[#4B5563] dark:text-gray-300 text-sm">
                    <span className="font-medium">IGST ({companyDetails.taxSlabs}%):</span>
                    <span>₹{summary.igstAmount}</span>
                  </div>
                )}
                
                <div className="flex justify-between items-center text-[#673AB7] dark:text-[#E9D5FF] text-lg font-bold border-t border-[#E5E7EB] dark:border-gray-600 pt-3 mt-3">
                  <span>Total Amount:</span>
                  <span>₹{formData.totalAmount}</span>
                </div>
                
                <div className="flex justify-between items-center text-[#4B5563] dark:text-gray-300 text-sm pt-2">
                  <span className="font-medium">Paid Amount:</span>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">₹</span>
                    <input
                      type="number"
                      name="paidAmount"
                      value={formData.paidAmount}
                      onChange={handleFormChange}
                      className={`pl-7 pr-3 py-1.5 w-32 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-600 dark:border-gray-500 text-right ${
                        formData.invoiceType === "Paid" || formData.invoiceType === "Unpaid" ? "bg-gray-100 cursor-not-allowed dark:bg-gray-800" : "bg-white"
                      }`}
                      min="0"
                      disabled={formData.invoiceType === "Paid" || formData.invoiceType === "Unpaid"}
                    />
                  </div>
                </div>
                
                <div className="flex justify-between items-center text-[#EF4444] text-base font-bold bg-[#FEF2F2] dark:bg-red-900/20 p-2 rounded-md mt-2">
                  <span>Due Amount:</span>
                  <span>₹{formData.dueAmount}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Submit Buttons */}
          <div className="flex justify-end gap-3 pb-8">
            {!submittedInvoiceId ? (
              <button
                onClick={handleSubmit}
                className="bg-[#673AB7] hover:bg-[#5E35A6] text-white px-6 py-2.5 rounded-md shadow-sm transition font-semibold text-sm"
              >
                {isEditMode ? "Update Invoice" : "Create Invoice"}
              </button>
            ) : (
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setFormData({
                      companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
                      invoiceType: "",
                      emailAutomation: false,
                      name: "",
                      companyName: "",
                      companyContact: "",
                      companyEmail: "",
                      gstNo: "",
                      gstType: "",
                      panNo: "",
                      stateName: "",
                      pinCode: "",
                      stateCode: "",
                      companyAddress: "",
                      termAndCondition: "",
                      createdById: user?.id,
                      createdByName: user?.name,
                      createdAt: new Date().toISOString().split("T")[0],
                      salesPerson: {
                        userId: "",
                        name: "",
                        mobileNumber: "",
                        email: "",
                      },
                      billDetails: {
                        subTotal: "0.00",
                        totalDiscount: 0,
                        totalAmount: 0.0,
                        paidAmount: 0.0,
                        dueAmount: 0.0,
                        cgstAmount: 0.0,
                        sgstAmount: 0.0,
                        igstAmount: 0.0,
                      },
                    });
                    setItems([
                      {
                        productName: "",
                        quantity: 1,
                        cost: 0,
                        discount: 0,
                        total: 0,
                        sacNo: "",
                        comment: "",
                      },
                    ]);
                    setSubmittedInvoiceId(null);
                  }}
                  className="bg-[#F3E8FF] hover:bg-[#E9D5FF] text-[#673AB7] border border-[#E9D5FF] px-6 py-2.5 rounded-md shadow-sm transition font-semibold text-sm"
                >
                  Create Another Invoice
                </button>
                <button
                  onClick={handleDownloadPDF}
                  className="bg-[#10B981] hover:bg-[#059669] text-white px-6 py-2.5 rounded-md shadow-sm transition font-semibold text-sm"
                >
                  Download PDF
                </button>
              </div>
            )}
          </div>
          
        </div>
      </div>
    </>
  );
}